import type { TPageTranslations } from '@crehana/i18n';

import { PAGE_KEY } from './constants';
import type { TKeys } from './types';

export const pt: TPageTranslations<TKeys, typeof PAGE_KEY> = {
  [PAGE_KEY]: {
    SEO_TITLE: 'Minhas solicitações | Presença | Crehana',
    SEO_DESCRIPTION:
      'Solicite ao seu administrador ou supervisor de presença trabalho de horas extras ou tempo compensatório.',

    PAGE_TITLE: 'Minhas solicitações',
    PAGE_DESCRIPTION:
      'Solicite ao seu administrador ou supervisor de presença trabalho de horas extras ou tempo compensatório.',
    BREADCRUMB_ATTENDANCE: 'Presença',
    BREADCRUMB_MY_REQUESTS: 'Minhas solicitações',
    BUTTON_CREATE_REQUEST: 'Criar solicitação',

    TABLE_HEADER_DATE: 'Data',
    TABLE_HEADER_SHIFT: 'Turno',
    TABLE_HEADER_OVERTIME: 'Horas extras',
    TABLE_HEADER_COMPENSATION: 'Tempo de compensação',
    TABLE_HEADER_REASON: 'Motivo',
    TABLE_HEADER_STATUS: 'Status',
    TABLE_HEADER_ACTIONS: 'Ações',

    STATUS_PENDING: 'Pendente',
    STATUS_APPROVED: 'Aprovada',
    STATUS_DENIED: 'Negada',
    STATUS_UPDATED_TOOLTIP:
      'O tempo final pode ser diferente do solicitado, pois corresponde ao tempo registrado durante a jornada e a possíveis ajustes feitos pelo administrador.',

    ACTION_CANCEL: 'Cancelar solicitação',
    ACTION_CANCEL_DISABLED_TOOLTIP:
      'Esta ação não está disponível para solicitações aprovadas.',

    EMPTY_STATE_TITLE: 'Ainda não há solicitações criadas',
    EMPTY_STATE_DESCRIPTION: 'Quando você fizer isso, elas vão aparecer aqui.',
    TABLE_ERROR_TITLE: 'Ocorreu um erro',
    TABLE_ERROR_DESCRIPTION: 'Clique no botão para tentar carregar novamente.',
    ERROR_STATE_RETRY: 'Tentar novamente',

    CREATE_DIALOG_TITLE: 'Criar solicitação',
    CREATE_DIALOG_OPEN_DAY_WARNING:
      'A quantidade solicitada poderá ser ajustada de acordo com o tempo efetivamente registrado na assiduidade daquele dia; se o registro for menor que o solicitado, apenas o tempo registrado será liquidado.',
    CREATE_DIALOG_DATE_LABEL: 'Data',
    CREATE_DIALOG_DATE_PLACEHOLDER: 'Selecione uma data',
    CREATE_DIALOG_SHIFT_LABEL: 'Turno',
    CREATE_DIALOG_SHIFT_PLACEHOLDER: 'Selecione a qual turno corresponde',
    CREATE_DIALOG_SHIFT_NONE_PLACEHOLDER: 'Este dia não tem turno atribuído',
    CREATE_DIALOG_SHIFT_NONE_TOOLTIP:
      'Você não tem turnos atribuídos para esta data',
    CREATE_DIALOG_SHIFT_ONE_TOOLTIP:
      'Você só tem um turno atribuído para esta data',
    CREATE_DIALOG_OVERTIME_LABEL: 'Horas extras',
    CREATE_DIALOG_COMPENSATION_LABEL: 'Tempo a compensar',
    CREATE_DIALOG_AMOUNT_PLACEHOLDER: 'HH:MM',
    CREATE_DIALOG_ROUNDING_PREVIEW:
      'Será registrado como {{value}} de acordo com a regra de arredondamento ativa.',
    CREATE_DIALOG_REASON_LABEL: 'Motivo',
    CREATE_DIALOG_REASON_PLACEHOLDER: 'Conte-nos o motivo da sua solicitação',
    CREATE_DIALOG_CANCEL: 'Cancelar',
    CREATE_DIALOG_SUBMIT: 'Salvar',

    VALIDATION_REQUIRED: 'Campo obrigatório.',
    VALIDATION_DATE_REQUIRED: 'Campo obrigatório.',
    VALIDATION_REASON_REQUIRED: 'Campo obrigatório.',
    VALIDATION_REASON_MAX_LENGTH:
      'O motivo não pode ultrapassar 250 caracteres.',
    VALIDATION_AMOUNT_FORMAT: 'Insira uma quantidade de tempo válida.',
    VALIDATION_AMOUNTS_EXCEED_DAY:
      'A soma de horas extras e tempo a compensar não pode superar 24 horas.',
    VALIDATION_DUPLICATE_REQUEST:
      'Já existe uma solicitação ou horas extras/compensação aprovada para esta data.',
    VALIDATION_SHIFT_REQUIRED: 'Campo obrigatório.',
    VALIDATION_SHIFT_NOT_RESOLVED:
      'Este dia tem mais de um turno. Tente novamente escolhendo o turno correto.',

    DELETE_ALERT_TITLE: 'Cancelar solicitação',
    DELETE_ALERT_DESCRIPTION:
      'Deseja cancelar sua solicitação do dia {{date}}? Ao fazer isso, ela deixará de aparecer na lista tanto para você quanto para o seu administrador.',
    DELETE_ALERT_CONFIRM: 'Cancelar solicitação',
    DELETE_ALERT_CANCEL: 'Voltar',

    TOAST_CREATE_SUCCESS: 'Sua solicitação foi criada.',
    TOAST_DELETE_SUCCESS: 'Sua solicitação foi cancelada.',
    TOAST_ERROR_GENERIC:
      'Não foi possível processar sua solicitação. Tente novamente.',

    REQUESTS_ACTION_VIEW_DETAIL: 'Ver detalhe',
  },
};
